import { styled, type Theme } from '@mui/material'
import type { StyledComponent } from '@mui/styles'
import type { MUIStyledCommonProps } from '@mui/system'

import { hubloTheme } from '@front/theme'

export const SplashScreenWrapper = styled('div')`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${hubloTheme.palette.background.default};
` as StyledComponent<React.PropsWithChildren<MUIStyledCommonProps<Theme>>>
